import { type Restaurant } from "api-types";

import { useSelector } from "react-redux";

import { type ReduxState } from "../types";

/**
 * Returns the currently selected restaurant.
 *
 * This is a shortcut for useSelector((state: ReduxState) => state.restaurant.selectedRestaurant)
 *
 * Care should be taken to call this hook only in the restaurant-mgmt layout.
 */
export const useRestaurant: () => Restaurant = () => {
  const restaurant = useSelector(
    (state: ReduxState) => state.restaurant.selectedRestaurant!
  );
  return restaurant;
};
